function tryOrOnError(target) {
    function tryCatcher() {
        try {
            tryCatcher.target.apply(this, arguments);
        }
        catch (e) {
            this.error(e);
        }
    }
    tryCatcher.target = target;
    return tryCatcher;
}
exports.tryOrOnError = tryOrOnError;
//# sourceMappingURL=tryOrOnError.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/tryOrOnError.js
 ** module id = 502
 ** module chunks = 1
 **/